import { BlankState } from '@domain-group/suit-theme'

const NoResultsBlankState = () => (
  <BlankState boxProps={{ marginBottom: 'large' }}>
    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Title>
      No Results Found
      {/*
     // @ts-expect-error TS2339 */}
    </BlankState.Title>

    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Paragraph>
      Cannot find any activity logs for this Service Product.
      {/*
     // @ts-expect-error TS2339 */}
    </BlankState.Paragraph>
  </BlankState>
)

export default NoResultsBlankState
